<template>
  <div class="content-pyramid-payments">
    <div class="col-xs-12 col-12 col-sm-10 col-sm-offset-1 offset-sm-1 col-md-8 col-md-offset-2 offset-md-2 mb-15">
      <div class="content-pyramid-payments__header">
        <h3>{{ content.title }}</h3>
        <p>{{ content.subtitle }}</p>
        <div class="row pyramid-payments-header__controls">
          <div class="col-xs-12 col-12 col-sm-6 col-lg-7">
            <select-filter
              v-model="selectedCategory"
              :selections="categories"
              :fluid="true"
              :label-icon="true"
              @input="handleUpdate"
              label="Select payment type"
              style="margin: 0px !important"
            />
          </div>

          <div class="control-radio text--primary col-xs-12 col-12 col-sm-6 col-lg-5">
            <div class="form-check" style="margin-right: 15px">
              <input
                class="form-check-input pyramid"
                type="radio"
                name="pyramid-payments-radio"
                checked
                value="past-three-months"
                @input="selectedFrequency = 'past-three-months'"
              />
              <span class="form-check-label text-legend legend-title__text" for="past-three-months">
                Past 3 months
              </span>
            </div>

            <div class="form-check">
              <input
                class="form-check-input pyramid"
                type="radio"
                name="pyramid-payments-radio"
                value="most-often"
                @input="selectedFrequency = 'most-often'"
              />
              <span class="form-check-label text-legend legend-title__text" for="most-often"> Most often </span>
            </div>
          </div>
        </div>
        <div class="pyramid-payments-header__legend">
          <div>
            <p v-for="n in legend" :key="n.group" class="legend-age text-legend">
              <span class="font-weight-bold">{{ n.group }}: </span>{{ n.age }}
            </p>
          </div>
          <p class="legend-gender text-legend"><span class="male" />Males</p>
          <p class="legend-gender text-legend"><span class="female" />Females</p>
        </div>
      </div>
      <!-- chart here -->
      <div class="row">
        <div class="content-pyramid-payments__chart col-xs-12 col-12 col-sm-6 mb-30" v-for="n in chartsByCountries" :key="n">
          <PyramidViz
            :frequency="selectedFrequency"
            :category="selectedCategory"
            :country="n"
            ref="pyramid"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SelectFilter from '@/components/ui/SelectFilter.vue';

export default {
  name: 'PyramidPayments',
  components: {
    SelectFilter,
    PyramidViz: () => import('@/components/content/chapter2/charts/PyramidViz.vue'),
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedCategory: 'E-wallets',
      selectedFrequency: 'past-three-months',
      legend: [
        { group: 'Youths', age: '18 - 24 years' },
        { group: 'Millennials', age: '25 - 39 years' },
        { group: 'Gen Xers', age: '40 - 54 years' },
        { group: 'Seniors', age: '55 years and above' },
      ],
      chartsByCountries: ['ASEAN-6', 'Indonesia', 'Malaysia', 'Philippines', 'Singapore', 'Thailand', 'Vietnam'],
      categories: [
        'Cash',
        'Debit/Credit cards',
        'E-wallets',
        'E-commerce payment platforms',
        'Mobile banking apps',
        'Mobile payment apps',
        'PayPal',
        'Others',
      ],
    };
  },
  methods: {
    loadCountries(data) {
      this.countries = data.map((d) => d.key);
    },
    handleUpdate(category) {
      this.selectedCategory = category;
    },
  },
};
</script>
<style lang="scss" scoped>
.content-pyramid-payments {
  &__header {
    margin-bottom: 30px;
    .pyramid-payments-header__controls {
      margin-bottom: 20px;
      .control-radio {
        display: flex;
        input[type='radio'] {
          -webkit-appearance: none;
          width: 14px;
          height: 14px;
          border: 1px solid #005eb8;
          border-radius: 50%;
          // margin-left: -20px !important;
        }
        input[type='radio']:before {
          content: '';
          display: block;
          width: 50%;
          height: 50%;
          margin: 25% auto;
          border-radius: 50%;
          border: unset;
        }
        input[type='radio']:checked:before {
          background: #005eb8;
        }
      }
    }
    .pyramid-payments-header__legend {
      p.legend-age {
        display: inline-block;
        margin-right: 24px;
      }
      p.legend-age:last-child {
        margin-right: unset;
      }
      p.legend-gender {
        span {
          width: 14px;
          height: 14px;
          display: inline-block;
          vertical-align: middle;
          margin-right: 5px;
          &.male {
            background-color: #005EB8;
          }
          &.female {
            background-color: #FDC4D0;
          }
        }
        display: inline-block;
        margin-right: 24px;
      }
      p.legend-gender:last-child {
        margin-right: unset;
      }
    }
    .pyramid-payments-header__commentary {
      background-color: #f0f0f0;
      border-radius: 5px;
      padding: 10px;
      p {
        margin-bottom: 0;
      }
    }
  }
  @media #{map-get($media-breakpoints, 'mobile')} {
    .control-radio {
      margin-top: 15px;
      margin-left: 8px;
    }
  }
}

.form-check .form-check-input.pyramid {
  margin-left: -20px !important;
  margin-top: 5px !important;
}
</style>
